export default __webpack_public_path__ + "static/media/bcm.8a656b82.png";